import React from "react";
import { connect } from "react-redux";
import { RootState } from "store/store";
import { EmailState } from "store/reducers/Emails";
import { Helmet } from "react-helmet";
import { useTheme } from "theme";

interface Props {
  title: string;
  hideTitle?: boolean;
  emailState: EmailState;
}

const PageMeta: React.FC<Props> = ({ emailState, title, hideTitle }: Props) => {
  const theme = useTheme();
  const unread = emailState.getEmails().filter(email => email.direction === "in" && !email.IsRead()).length;
  const currentIcon = document.querySelector<HTMLLinkElement>("link[rel*='icon']");

  if (unread > 0) {
    currentIcon?.setAttribute("href", theme.assets.unreadFavicon)
  } else {
    currentIcon?.setAttribute("href", theme.assets.favicon)
  }

  if (unread > 0) {
    title = `(${unread}) ${title}`
  }

  if (hideTitle === undefined || !hideTitle) {
    title = `${title} | ${theme.brand.productName} | ${theme.brand.companyName}`
  }


  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    emailState: state.Emails
  };
};

export default connect(mapStateToProps)(PageMeta);
